import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SchedulerCalendarEventType } from 'sb-lib/types';
import { getSchedulerCalendarEventTypes } from 'shared/api';
import log from 'shared/utils/log';

export interface SchedulingState {
  eventTypes: SchedulerCalendarEventType[];
  loading: boolean;
  error: string | null;
}

const initialState: SchedulingState = {
  eventTypes: [],
  loading: false,
  error: null,
};

export const fetchEventTypes = createAsyncThunk(
  'scheduling/fetchEventTypes',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSchedulerCalendarEventTypes({});
      return response.data;
    } catch (err) {
      log.error('Failed to fetch scheduling event types', undefined, err);
      return rejectWithValue(err.message || 'Failed to fetch event types');
    }
  },
);

const schedulingSlice = createSlice({
  name: 'scheduling',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(fetchEventTypes.pending, state => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchEventTypes.fulfilled, (state, action) => {
        state.eventTypes = action.payload;
        state.loading = false;
      })
      .addCase(fetchEventTypes.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default schedulingSlice.reducer;
